import { createSelector } from 'reselect'

import { getFurnitureById as getProductsById } from 'models/furniture/selectors'

export const getIds = (state) => state.favorites.ids

export const getHasFavoritesList = createSelector([getIds], (ids) => !!ids && Array.isArray(ids))

export const getFavoriteProducts = createSelector([getIds, getProductsById], (favIds, productsById) => {
    if (favIds) {
        const products = Object.values(productsById)
        return favIds.map((favId) => products.find((furni) => furni.localItemNumber === favId)).filter((i) => !!i)
    }
    return []
})

export const getNumFavorites = createSelector([getIds], (favIds) => (favIds ? favIds.length : 0))
